import { Box, Table } from '@chakra-ui/react'
import { DateTime } from 'luxon'
import { useState } from 'react'

import { ITNETableColumn, ITNETableRow } from '@/types/tasksApprovals'
import { formatDate } from '@/utils/date'

export const TableRow = ({ row, columns, columnsLength }: { row: ITNETableRow; columns: ITNETableColumn[]; columnsLength: number }) => {
    const isHighlighted = row.comments || row.remark
    const highlightedColor = 'var(--chakra-colors-status-error)'
    const highlightedBorderWidhth = '4px'
    const bordercolor = 'rgba(240, 239, 237, 1)'
    const [showRemark, setShowRemark] = useState(false)

    const toggleRemark = () => {
        setShowRemark(!showRemark)
    }
    return (
        <>
            <Table.Row
                backgroundColor={'transparent'}
                borderLeftColor={isHighlighted ? highlightedColor : ''}
                borderLeftWidth={isHighlighted ? highlightedBorderWidhth : ''}
            >
                {columns.map((column, index: number) => {
                    if (column.field === 'comments' || column.field === 'remark') {
                        return
                    }
                    return (
                        <Table.Cell
                            key={column.field}
                            borderBottom={isHighlighted ? '0 none' : ''}
                            borderColor={bordercolor}
                            textAlign={index === 0 ? 'left' : 'center'}
                            fontSize={'14px'}
                        >
                            <b>{column.field === 'date' ? formatDate(row[column.field], DateTime.DATE_SHORT) : row[column.field]}</b>
                        </Table.Cell>
                    )
                })}

                <Table.Cell borderBottom={isHighlighted ? '0 none' : ''} borderColor={bordercolor} fontSize={'14px'}>
                    {row.remark && (
                        <Box
                            cursor="pointer"
                            fontWeight="bold"
                            fontSize={'16px'}
                            onClick={() => toggleRemark()}
                            transform={showRemark ? 'rotate(90deg)' : ''}
                            textAlign={'center'}
                            padding={'0 8px'}
                        >
                            {'>'}
                        </Box>
                    )}
                </Table.Cell>
            </Table.Row>
            {row.comments && (
                <Table.Row
                    backgroundColor={'transparent'}
                    borderLeftColor={isHighlighted ? highlightedColor : ''}
                    borderLeftWidth={isHighlighted ? highlightedBorderWidhth : ''}
                >
                    <Table.Cell
                        colSpan={columnsLength}
                        borderBottom={showRemark ? '0 none' : ''}
                        pb={showRemark ? '0' : ''}
                        pt="0"
                        borderColor={bordercolor}
                    >
                        Comment: <b>{row.comments}</b>
                    </Table.Cell>
                </Table.Row>
            )}
            {row.remark && showRemark && (
                <Table.Row
                    backgroundColor={'transparent'}
                    borderLeftColor={isHighlighted ? highlightedColor : ''}
                    borderLeftWidth={isHighlighted ? highlightedBorderWidhth : ''}
                >
                    <Table.Cell colSpan={columnsLength} borderColor={bordercolor}>
                        Remark: <b>{row.remark}</b>
                    </Table.Cell>
                </Table.Row>
            )}
        </>
    )
}
